import React, { useEffect, useState } from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "./Files.scss";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
type AppProps = {
  imageDetails: ImageDataType;
};
const PdfPreview = ({ imageDetails }: AppProps) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [imageDetails]);

  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const docs = [
    {
      uri: imageDetails?.imageUrl ? imageDetails?.imageUrl : "",
      fileType: "pdf",
    },
  ];

  const headers = {
    "X-Access-Token": blobToken ? blobToken : "",
    "Content-Type": "application/pdf",
  };

  return (
    <DocViewer
      key={key}
      documents={[...docs]}
      pluginRenderers={DocViewerRenderers}
      prefetchMethod="GET"
      requestHeaders={headers}
    />
  );
};

export default PdfPreview;
